{
	"title": "Materials",
	"favorites": {
		"title": "Favorites",
		"subtitle": "{materials} · {sets}",
		"subtitleEmpty": "Empty so far",
		"empty": {
			"title": "No favorites yet",
			"description": "Star materials or folders to keep them here for quick access.",
			"cta": "Go to materials"
		}
	},
	"subtitle": "{materials} · {sets}",
	"back": "Back",
	"openInLibrary": "Open in my library",
	"list": {
		"title": "My materials",
		"empty": {
			"heading": "All your lectures, notes and PDFs will live here",
			"description": "Upload your first material — StudyHub turns it into key ideas, flashcards and quizzes.",
			"cta": "Upload material",
			"secondary": "Record lecture"
		},
		"emptyFiltered": {
			"heading": "No matches for current filters",
			"reset": "Reset filters"
		},
		"count": "{count, plural, =0 {No materials} one {# material} other {# materials}}",
		"setsCount": "{count, plural, =0 {No folders} one {# folder} other {# folders}}",
		"searchPlaceholder": "Search materials",
		"view": {
			"grid": "Grid",
			"list": "List"
		},
		"sort": {
			"label": "Sort",
			"updatedAt": "Updated",
			"createdAt": "Created",
			"title": "Title"
		},
		"filters": {
			"type": "Type",
			"set": "Folder",
			"status": "Status",
			"tags": "Tags",
			"allTypes": "All types",
			"allSets": "All folders",
			"allStatuses": "All statuses",
			"reset": "Reset all",
			"recent": "Recent",
			"favorite": "Favorites",
			"processing": "Processing",
			"ready": "Ready",
			"sortLabel": "Sort"
		},
		"table": {
			"name": "Name",
			"type": "Type",
			"set": "Folder",
			"updated": "Updated",
			"status": "Status",
			"actions": "Actions"
		},
		"loadMore": "Load more",
		"showing": "Showing {shown} of {total}",
		"summary": "{total, plural, one {# material} other {# materials}} · {processing} in progress · {ready} ready",
		"row": {
			"noteReady": "Note ready",
			"noArtifacts": "No artifacts yet",
			"actions": "Actions"
		},
		"errors": {
			"loadFailed": "Failed to load materials",
			"retry": "Retry"
		},
		"newSet": "New folder",
		"filtersButton": "Filters",
		"filtersSheet": {
			"title": "Filters & sorting",
			"done": "Done"
		},
		"swipe": {
			"delete": "Trash",
			"favorite": "Favorite",
			"unfavorite": "Unfavorite",
			"removeFromSet": "Remove"
		}
	},
	"artifacts": {
		"note": "Note",
		"flashcards": "Cards",
		"quiz": "Quiz",
		"noteCount": "{count, plural, one {# note} other {# notes}}",
		"flashcardsCount": "{count, plural, one {# card} other {# cards}}",
		"quizCount": "{count, plural, one {# test} other {# tests}}"
	},
	"card": {
		"openMenu": "Menu",
		"favorite": "Add to favorites",
		"unfavorite": "Remove from favorites",
		"select": "Select material",
		"noSet": "No folder",
		"processingProgress": "{percent}%"
	},
	"workspace": {
		"title": "Material",
		"askAi": "Ask about this material",
		"tabs": {
			"note": "Note",
			"flashcards": "Flashcards",
			"quiz": "Quiz",
			"glossary": "Glossary",
			"voice": "Voice tutor",
			"recording": "Recording",
			"audio": "Audio recap",
			"source": "Source",
			"scrollLeft": "Scroll left",
			"scrollRight": "Scroll right",
			"extracted": "Extracted"
		},
		"tabsLocked": {
			"audio": "Available on Plus"
		},
		"preview": {
			"page": "{current} / {total}",
			"noPreview": "No preview",
			"noPreviewDescription": "This format does not support inline preview yet",
			"openSource": "Open source",
			"noText": "Text hasn't been extracted from this material yet.",
			"processing": "Material is still processing…",
			"openDocument": "Open document",
			"openDocumentHint": "The document will open in a new tab"
		},
		"panels": {
			"note": {
				"ready": "Note ready",
				"regenerate": "Regenerate",
				"createNew": "New note",
				"levels": {
					"summarized": "Summary",
					"in-depth": "In-depth",
					"comprehensive": "Comprehensive"
				},
				"empty": "Note not generated yet",
				"generate": "Generate note",
				"advanced": "Choose detail level",
				"generating": "Generating note…",
				"generatingDescription": "Turning your material into a structured note. This takes a couple of minutes.",
				"listTitle": "Notes"
			},
			"flashcards": {
				"count": "{count, plural, one {# card} other {# cards}}",
				"study": "Start review",
				"empty": "No flashcards yet",
				"generate": "Generate flashcards",
				"openSet": "Open set",
				"generating": "Generating flashcards…",
				"generatingDescription": "Creating flashcards for review. This takes a couple of minutes.",
				"failed": "Failed to generate flashcards",
				"createNew": "New set",
				"listTitle": "Flashcard sets"
			},
			"quiz": {
				"count": "{count, plural, one {# question} other {# questions}}",
				"empty": "No quizzes yet",
				"generate": "Generate quiz",
				"open": "Open quiz",
				"generating": "Generating quiz…",
				"generatingDescription": "Preparing questions from your material. This takes a couple of minutes.",
				"createNew": "New test",
				"listTitle": "Tests"
			},
			"recording": {
				"none": "This material isn't a lecture recording",
				"open": "Open recording",
				"openList": "Open lecture recordings"
			},
			"audio": {
				"empty": "No audio recap yet",
				"generate": "Generate audio recap",
				"play": "Play",
				"generating": "Generating audio recap…",
				"generatingDescription": "Generating an audio recap of your material. This takes a couple of minutes.",
				"createNew": "New audio",
				"listTitle": "Audio recaps"
			},
			"voice": {
				"empty": "No voice tutor sessions yet",
				"start": "Start a voice session",
				"createNew": "New session",
				"open": "Open",
				"listTitle": "Voice sessions"
			}
		},
		"meta": {
			"pages": "{count, plural, one {# page} other {# pages}}",
			"minutes": "{count, plural, one {# min} other {# min}}"
		},
		"artefacts": {
			"title": "From this material",
			"flashcards": "{count, plural, one {# card} other {# cards}}",
			"flashcardsSub": "Anki-style, ready to review",
			"quiz": "{count, plural, one {# quiz question} other {# quiz questions}}",
			"quizSub": "Ready to take",
			"audio": "{minutes} min audio",
			"audioSub": "Podcast dialogue from this material",
			"glossary": "{count, plural, one {# term} other {# terms}}",
			"glossarySub": "Auto glossary for this material",
			"voice": "{count, plural, one {# session} other {# sessions}}",
			"voiceSub": "A live voice lesson with the AI tutor on this material",
			"noteSub": "Structured AI note for this material",
			"noteReady": "{count, plural, one {# note ready} other {# notes ready}}",
			"status": {
				"ready": "Ready",
				"missing": "Not created",
				"generating": "Generating",
				"failed": "Failed"
			},
			"cta": {
				"generate": "Create note",
				"create": "Create",
				"retry": "Retry",
				"openNote": "Open note",
				"openGlossary": "Open glossary",
				"startVoice": "Start session"
			}
		},
		"ask": {
			"title": "Ask about this material",
			"placeholder": "Ask a question about this material…",
			"samples": {
				"q1": "Explain the topic in simple terms",
				"q2": "Give a short summary of the material",
				"q3": "Quiz me on this topic",
				"q4": "What's the most important here?"
			}
		},
		"favorite": "Add to favorites",
		"unfavorite": "Remove from favorites",
		"share": "Share",
		"regenerate": "Regenerate",
		"askTutor": "Start chat",
		"voiceTutor": "Voice tutor",
		"allMaterials": "All materials",
		"menu": "Menu",
		"actions": {
			"openNotes": "All notes",
			"rename": "Rename",
			"delete": "Delete material"
		},
		"rename": {
			"title": "Rename material",
			"label": "Title",
			"save": "Save",
			"cancel": "Cancel"
		},
		"deleteConfirm": {
			"title": "Delete material?",
			"description": "The material moves to trash for 30 days, then is permanently deleted.",
			"confirm": "Delete",
			"cancel": "Cancel"
		},
		"toasts": {
			"genStarted": "Generation started — this takes a couple of minutes",
			"genFailed": "Couldn't start generation",
			"genSlow": "Generation is taking longer than usual — the result will appear here as soon as it's ready",
			"shared": "Link copied",
			"shareFailed": "Couldn't create link",
			"favorited": "Added to favorites",
			"unfavorited": "Removed from favorites",
			"regenerating": "Regeneration started",
			"renamed": "Title updated",
			"deleted": "Material deleted",
			"actionFailed": "Action failed",
			"offlineDeleteRequiresNetwork": "Deleting a material requires a network connection"
		},
		"states": {
			"processing": "Processing…",
			"processingDescription": "Processing your material — this takes a couple of minutes.",
			"materialProcessing": "Material is still processing",
			"materialProcessingDescription": "Wait until processing finishes — then you can generate flashcards, a quiz and audio.",
			"error": "Processing failed",
			"errorDescription": "Something went wrong. Try again.",
			"retry": "Retry",
			"notFound": "Material not found",
			"notFoundDescription": "The material was deleted or you don’t have access.",
			"loadFailed": "Couldn’t load material",
			"loadFailedDescription": "Check your connection and try again.",
			"retryLoad": "Retry",
			"syncPending": "Waiting for sync",
			"syncPendingDescription": "You’re offline or data hasn’t synced yet. Try again later.",
			"ready": "Ready",
			"queued": "Queued",
			"generated": "Done",
			"generatedDescription": "Material is ready — opening.",
			"generatingShort": "Generating…"
		},
		"courses": {
			"title": "Used in courses",
			"empty": "Not part of any course yet.",
			"error": "Couldn't load course links. Try again later.",
			"continueTopic": "Continue: {title}",
			"noProgram": "Program not built yet",
			"add": "Add to course",
			"addDescription": "The material joins the course sources and is used when its program is built.",
			"addPlaceholder": "Pick a course",
			"addEmpty": "This material is already in every course you have.",
			"addEmptyCta": "Go to courses",
			"added": "Added to the course",
			"addError": "Couldn't add to the course"
		},
		"video": {
			"speed": "Playback speed",
			"speedValue": "Speed {rate}×",
			"rewind": "Back {seconds} seconds",
			"forward": "Forward {seconds} seconds",
			"captions": "Current transcript line",
			"transcript": "Transcript",
			"noTranscript": "This video has no transcript yet.",
			"transcriptTruncated": "{count, plural, one {# more fragment is not shown} other {# more fragments are not shown}}"
		}
	},
	"upload": {
		"button": "Upload",
		"uploadMaterial": "Upload material",
		"dialog": {
			"title": "Upload material"
		},
		"tabs": {
			"file": "File",
			"link": "Link",
			"text": "Text"
		},
		"file": {
			"drop": "Drop files here or click to choose",
			"dropActive": "Release to upload",
			"formats": "PDF · Word · Excel · PowerPoint · Text · Markdown · image · audio · video",
			"unsupported": "This format is not supported.",
			"tooMany": "You can upload up to {max} files at once.",
			"maxFiles": "Up to {max} files at a time",
			"phaseHashing": "Preparing files…",
			"phaseUploading": "Uploading: {percent}%",
			"phaseUploadingBatch": "Uploading {current}/{total}: {percent}%",
			"phaseFinalizing": "Processing…",
			"phasePacking": "Starting folder pack…",
			"processingHint": "Keep this window open while files upload.",
			"readyHint": "Files are ready — pick a course or folder, then tap Done.",
			"addMore": "Add more files",
			"choose": "Choose files",
			"chooseHint": "Or drag files here"
		},
		"link": {
			"placeholder": "Paste a YouTube or web page link",
			"hint": "YouTube or any web page — detected automatically",
			"detectedYoutube": "Detected: YouTube",
			"detectedWebpage": "Detected: web page",
			"submit": "Add"
		},
		"text": {
			"titlePlaceholder": "Title (optional)",
			"contentPlaceholder": "Paste or type text…",
			"untitled": "Untitled",
			"submit": "Save"
		},
		"cancel": "Cancel",
		"done": "Done",
		"duplicate": "This material is already uploaded",
		"destination": "Where to add",
		"course": {
			"label": "Course",
			"placeholder": "Pick a course",
			"search": "Search a course",
			"newCourse": "＋ New course",
			"newCoursePlaceholder": "Course title",
			"libraryOnly": "Library only",
			"empty": "No courses yet",
			"current": "To course: {course}",
			"change": "change"
		},
		"folder": {
			"label": "Folder",
			"placeholder": "No folder",
			"search": "Search a folder",
			"newFolder": "＋ New folder",
			"newFolderPlaceholder": "Folder name",
			"empty": "No folders yet"
		},
		"hint": "We'll build a program from these materials",
		"hintLibraryOnly": "The materials stay in the library — no program is built",
		"bridge": {
			"title": "{count, plural, one {# material processed} other {# materials processed}}",
			"description": "The program of «{course}» is ready to continue.",
			"action": "Go to learning",
			"dismiss": "Later"
		},
		"types": {
			"pdf": "PDF",
			"doc": "Document",
			"spreadsheet": "Spreadsheet",
			"presentation": "Presentation",
			"image": "Image",
			"audio": "Audio",
			"video": "Video",
			"youtube": "YouTube",
			"webpage": "Web page",
			"text": "Text",
			"note": "Note"
		},
		"kindBadge": {
			"pdf": "PDF",
			"doc": "DOC",
			"text": "TEXT",
			"image": "IMAGE",
			"audio": "AUDIO",
			"video": "VIDEO",
			"youtube": "YT",
			"web": "WEB"
		},
		"progress": "Uploading: {percent}%",
		"success": "Material uploaded",
		"successToCollection": "Material added to the folder",
		"successToNewCollection": "Files uploaded — folder created",
		"errors": {
			"tooLarge": "File is too large (max {maxMb} MB)",
			"tooLargeTier": "File exceeds your plan limit",
			"unsupportedType": "This format is not supported",
			"quotaExceeded": "Material quota reached for your plan",
			"invalidUrl": "Check the link — it looks invalid",
			"network": "Upload failed. Check your connection and try again",
			"generic": "Something went wrong. Please try again",
			"tooLargeLimit": "File is too large to upload",
			"quotaReachedLimit": "Material limit reached"
		}
	},
	"status": {
		"queued": "Queued",
		"processing": "Processing",
		"ready": "Ready",
		"partial": "Partially ready",
		"failed": "Processing failed",
		"retry": "Retry processing"
	},
	"sets": {
		"title": "Folders",
		"createButton": "Create folder",
		"empty": "No folders",
		"namePlaceholder": "Folder name",
		"counters": {
			"empty": "Empty",
			"materials": "{count, plural, =0 {No materials in this folder} one {# material in this folder} other {# materials in this folder}}",
			"flashcards": "{count, plural, =0 {No cards generated yet} one {# card generated from this folder} other {# cards generated from this folder}}",
			"tests": "{count, plural, =0 {No tests generated yet} one {# test generated from this folder} other {# tests generated from this folder}}"
		},
		"list": {
			"title": "Folders",
			"subtitle": "{count, plural, =0 {No folders} one {# folder} other {# folders}} · {materialsCount, plural, =0 {no materials} one {# material} other {# materials}}",
			"search": "Search by name",
			"empty": {
				"title": "No folders yet",
				"subtitle": "Group materials by subject or course",
				"cta": "Create your first folder"
			},
			"emptyFiltered": {
				"heading": "Nothing found",
				"hint": "Adjust your query or reset filters"
			},
			"card": {
				"materials": "{count, plural, =0 {No materials} one {# material} other {# materials}}",
				"flashcards": "{count, plural, =0 {0 cards} one {# card} other {# cards}}",
				"tests": "{count, plural, =0 {0 tests} one {# test} other {# tests}}"
			},
			"view": {
				"label": "View",
				"grid": "Grid",
				"table": "List"
			},
			"sort": {
				"label": "Sort",
				"placeholder": "By updated",
				"updatedAt": "By updated",
				"createdAt": "By created",
				"name": "By name",
				"materialsCount": "By materials count"
			},
			"table": {
				"name": "Name",
				"description": "Description",
				"materials": "Materials",
				"flashcards": "Cards",
				"tests": "Tests",
				"updated": "Updated",
				"created": "Created",
				"actions": ""
			},
			"reorder": {
				"toastSuccess": "Folders order saved",
				"toastError": "Failed to save order",
				"dragHandle": "Drag",
				"moveUp": "Move up",
				"moveDown": "Move down"
			}
		},
		"detail": {
			"stats": "{materials} materials · {flashcards} cards · {quizzes} quizzes",
			"share": "Share",
			"shareCopied": "Link copied",
			"shareRevoke": "Revoke",
			"addMaterials": "Add materials",
			"reorder": "Reorder",
			"searchInSet": "Search in folder",
			"empty": "This folder is empty yet",
			"emptyAdd": "Add materials",
			"removeFromSet": "Remove from folder",
			"removedFromSet": "Material removed from folder"
		},
		"menu": {
			"aria": "Folder actions",
			"open": "Open",
			"rename": "Edit",
			"color": "Change color",
			"share": "Share",
			"shareCopied": "Link copied",
			"revokeShare": "Revoke access",
			"shareRevoked": "Access revoked",
			"duplicate": "Duplicate",
			"duplicateStarted": "Duplicating folder — materials will appear in a few seconds",
			"duplicateReady": "Folder copy is ready",
			"duplicateError": "Couldn't duplicate the folder",
			"export": "Export",
			"exportStarted": "Preparing archive — we'll send a link",
			"exportReady": "Folder archive is ready — download will start",
			"exportError": "Failed to export the folder",
			"delete": "Delete",
			"moveUp": "Move up",
			"moveDown": "Move down",
			"movedUp": "Folder moved up",
			"movedDown": "Folder moved down"
		},
		"delete": {
			"title": "Delete this folder?",
			"body": "Materials inside the folder will NOT be deleted. The folder and its shared artifacts will move to trash for 30 days.",
			"cta": "Delete folder",
			"success": "Folder deleted",
			"error": "Failed to delete folder",
			"removedFromAnotherDevice": "Folder deleted from another device"
		},
		"edit": {
			"title": "Edit folder",
			"subtitle": "Name, description and color.",
			"nameLabel": "Name",
			"descriptionLabel": "Description",
			"colorLabel": "Color",
			"cta": "Save",
			"cancel": "Cancel",
			"success": "Changes saved",
			"error": "Failed to save"
		},
		"addMaterialsDialog": {
			"title": "Add materials to folder",
			"subtitle": "Pick materials from your library that aren't in the folder yet.",
			"success": "Materials added to the folder",
			"error": "Couldn't add materials",
			"cancel": "Cancel",
			"cta": "{count, plural, =0 {Add} one {Add # material} other {Add # materials}}"
		}
	},
	"trash": {
		"title": "Trash",
		"subtitle": "{count, plural, =0 {Trash is empty} one {# material} other {# materials}} · kept for 30 days",
		"banner": "Materials are kept for 30 days. After that they are deleted permanently. Folder links are restored on restore.",
		"restore": "Restore",
		"delete": "Delete permanently",
		"emptyTrash": "Empty trash",
		"emptyTrashConfirm": "Empty trash?",
		"emptyTrashConfirmDescription": "All materials will be deleted permanently. Type «DELETE» to confirm.",
		"deleteWord": "DELETE",
		"deletesIn": "Deletes in {days}d {hours}h",
		"deletedAt": "Deleted {time}",
		"empty": {
			"heading": "Trash is empty",
			"description": "Deleted materials land here and are kept for 30 days."
		},
		"table": {
			"name": "Name",
			"type": "Type",
			"size": "Size",
			"deleted": "Deleted",
			"expiresIn": "Deletes in"
		},
		"selected": "Selected: {count}",
		"restored": "Material restored",
		"emptied": "Trash emptied"
	},
	"share": {
		"title": "Share material",
		"copyLink": "Copy link",
		"linkCopied": "Link copied",
		"expiresIn": "Expires in {days} days",
		"publicHeading": "Public material",
		"publicSubheading": "Sign up to take the quiz, chat with AI or review flashcards.",
		"signupCta": "Create account",
		"watermark": "Published on StudyHub",
		"viewBy": "Shared by: {name}",
		"notFoundTitle": "Link unavailable",
		"notFoundDescription": "This share link is invalid, expired or was revoked by the owner.",
		"contentEmpty": "This material has no readable text content to preview.",
		"setHeading": "Shared folder",
		"setMaterialsCount": "{count, plural, one {# material} other {# materials}}",
		"openInApp": "Open in StudyHub"
	},
	"actions": {
		"open": "Open",
		"rename": "Rename",
		"moveToSet": "Move to folder",
		"share": "Share",
		"download": "Download",
		"duplicate": "Duplicate",
		"delete": "Delete material",
		"deleteConfirm": "Delete this material and all related notes, flashcards and quizzes?"
	},
	"processing": {
		"status": {
			"queued": "In queue",
			"uploading": "Uploading",
			"parsing": "Reading content",
			"ocr": "Recognizing text",
			"chunking": "Splitting into fragments",
			"embedding": "Building the index",
			"ready": "Ready",
			"failed": "Processing failed",
			"partial": "Partially ready",
			"cancelled": "Cancelled",
			"unknown": "Processing"
		},
		"actions": {
			"retry": "Retry"
		},
		"errorCode": {
			"no-text-extractable": "Couldn't extract text from the file",
			"no-speech-detected": "No speech detected in the audio",
			"ai-timeout": "AI took too long to respond",
			"safety-filter": "Content blocked by the safety filter",
			"file-too-large": "File is too large",
			"unsupported-format": "Unsupported file format",
			"unsupported-type": "Unsupported material type",
			"pdf-encrypted": "The PDF is password-protected",
			"pdf-too-many-pages-for-ocr": "Too many pages for text recognition",
			"youtube-private": "The video is private",
			"youtube-not-found": "Video not found",
			"youtube-invalid-url": "Invalid video link",
			"youtube-live-stream": "Live streams aren't supported",
			"youtube-too-long": "The video is too long",
			"webpage-paywall": "The page is behind a paywall",
			"webpage-no-content": "Couldn't find content on the page",
			"thin": "Too little readable text on the page — it may be a script shell or blocked. Paste the text manually or try another source",
			"webpage-blocked": "Access to the page is blocked",
			"audio-too-long": "The audio is too long",
			"pptx-too-many-slides-for-ocr": "Too many slides for text recognition",
			"rate-limit": "Request limit reached, try again later",
			"quota-exceeded": "Processing quota exceeded",
			"material-not-found": "Material not found",
			"type-mismatch": "File type doesn't match the material",
			"invalid-source": "Material source is corrupted or missing",
			"user-cancelled": "Processing cancelled",
			"provider-unavailable": "The AI service is temporarily unavailable",
			"mime-mismatch": "The file format doesn't match its extension",
			"upload-incomplete": "Upload didn't finish",
			"internal-error": "Internal error",
			"claim-idempotency": "Processing is already running",
			"validate": "File validation failed"
		},
		"stages": {
			"text": "Extracting text",
			"index": "Indexing",
			"assets": "Tables and images",
			"assetsBackground": "— in the background"
		}
	},
	"extracted": {
		"sourceChipWithPage": "{name} · p. {page}",
		"lightboxAria": "Figure viewer",
		"close": "Close",
		"loadFailed": "Could not load extracted content",
		"retry": "Retry",
		"page": "p. {page}",
		"openFigure": "Open figure: {name}",
		"hide": "Hide from AI suggestions",
		"unhide": "Return to AI suggestions",
		"hiddenLabel": "{name} — hidden",
		"kind": {
			"figure": "Diagram",
			"photo": "Photo",
			"formula": "Formula",
			"chart": "Chart",
			"screenshot": "Screenshot",
			"table-image": "Table image",
			"page-render": "Page"
		},
		"summary": {
			"pages": "{count, plural, one {# page} other {# pages}}",
			"tables": "{count, plural, one {# table} other {# tables}}",
			"figures": "{count, plural, one {# figure} other {# figures}}"
		},
		"figures": {
			"title": "Figures",
			"empty": "No figures found",
			"pending": "Figures are still being extracted"
		},
		"tables": {
			"title": "Tables",
			"empty": "No tables found",
			"pending": "Tables are still being extracted",
			"untitled": "Untitled table",
			"size": "{rows}×{cols}",
			"irregular": "simplified view",
			"expand": "Expand",
			"collapse": "Collapse",
			"noProjection": "Table markup unavailable"
		}
	}
}
